import { render } from "./LinkageNewPassword.vue?vue&type=template&id=fd5ff65c&scoped=true&ts=true"
import script from "./LinkageNewPassword.vue?vue&type=script&lang=ts"
export * from "./LinkageNewPassword.vue?vue&type=script&lang=ts"

import "./LinkageNewPassword.vue?vue&type=style&index=0&id=fd5ff65c&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src845797062/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5ff65c"]])

export default __exports__